import { useTranslation } from "react-i18next";

const useGetLang = (idLang) => {
    const { t } = useTranslation();

    // Kiểm tra nếu idLang không được cung cấp hoặc không hợp lệ
    if (!idLang) {
        console.warn("idLang is required but was not provided.");
        return '';
    }

    return t(idLang);
};

export default useGetLang;
